import React, { useEffect } from "react";
import { PerspectiveCamera } from "@react-three/drei";

import type { NvsCameraControlsProps } from "./types";
import { getControlsFromType } from "./utils";
import { useIsAutoplayAndVisible } from "../../hooks";
import { useThree } from "@react-three/fiber";

export const NvsCameraControls: React.FC<NvsCameraControlsProps> = ({
  children,
  controls,
  fov,
  near,
  far,
  transform3D,
}: NvsCameraControlsProps) => {
  const { Controls, defaultProps } = getControlsFromType(controls);

  // Enable/disable events based on autoplay (used for mobile devices in unexpanded modal) to prevent scroll-hijacking
  const isAutoplayAndVisible = useIsAutoplayAndVisible();
  const eventsManager = useThree((state) => state.events);
  useEffect(() => {
    eventsManager.enabled = !isAutoplayAndVisible;
  }, [isAutoplayAndVisible, eventsManager]);

  return (
    <>
      <PerspectiveCamera
        makeDefault
        position={transform3D?.position}
        rotation={transform3D?.rotation}
        scale={transform3D?.scale}
        near={near}
        far={far}
        fov={fov}
      />
      {Controls ? (
        <Controls props={defaultProps}>{children}</Controls>
      ) : (
        <>{children}</>
      )}
    </>
  );
};
